import React from 'react';
import ReactDOM from 'react-dom';
import {
  BrowserRouter as Router
} from "react-router-dom";
import { Provider } from 'react-redux';
import store from './store';
import App from './App';


// Save to session storage
store.subscribe(()=>{
  sessionStorage.setItem('userData', JSON.stringify(store.getState().formReducer.formData))
})

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router basename={process.env.BASE_NAME}>
        <App />
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
